import React from "react";
import MailIcon from "../img/images/icons/social-icon-mail.svg";
import InstagramIcon from "../img/images/icons/social-icon-instagram.svg";
import YoutubeIcon from "../img/images/icons/social-icon-youtube.svg";
import LinkedInIcon from "../img/images/icons/social-icon-linkedin.svg";
import FacebookIcon from "../img/images/icons/social-icon-facebook.svg";
import UNSLogo from "../img/images/Unschool Logo Horizontal White (1).png";
import "./sections/footer.scss";

const Footer = class extends React.Component {
  render() {
    return (
      <div id="footer" className="footer-section">
        <div className="footer-main">
          <div className="location-wrapper footer-column">
            <div className="unschool-logo-wrapper">
              <img alt="unschool-logo" src={UNSLogo} />
            </div>
            <p className="footer-subtitle">
              SNP Towers, 2nd Floor Janardhana Hills Serilingampally,
              Gachibowli, Hyderabad, Telangana 500032
            </p>
            <FooterSocialLinks />
          </div>
          <div className="footer-links-content-wrapper">
            <div className="footer-column">
              <h1 className="footer-title">Company</h1>
              <div className="footer-links-container">
                <a href="/about" className="footer-link">
                  About us
                </a>
                <a href="/contact" className="footer-link">
                  Contact us
                </a>
                <a href="/community-program" className="footer-link">
                  Community Program
                </a>
                <a href="/work-with-us" className="footer-link">
                  Work with Us
                </a>
                <a
                  href="https://app6.talentrackr.com/Unschool/UnschoolHome.aspx"
                  target="_blank"
                  className="footer-link"
                >
                  Internships
                </a>
                <a
                  target="_blank"
                  href="https://community.unschool.in/signup"
                  className="footer-link join-community-link"
                >
                  Join our community
                </a>
                <a href="/partner-with-us" className="footer-link">
                  Partner with us
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h1 className="footer-title">Policies</h1>
              <div className="footer-links-container">
                <a href="/policies/disclaimer" className="footer-link">
                  Disclaimer
                </a>
                <a href="/policies/terms_of_service" className="footer-link">
                  Terms of Service
                </a>
                <a
                  href="/policies/refund_and_cancellation"
                  className="footer-link"
                >
                  Refund and Cancellation
                </a>
                <a href="/policies/privacy_policy" className="footer-link">
                  Privacy Policy
                </a>
                <a href="/policies/payment_terms" className="footer-link">
                  Payment Terms
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h1 className="footer-title">Become a coach</h1>
              <div className="footer-links-container">
                <a href="/become-a-coach/" className="footer-link">
                  Coach with us
                </a>
                <a
                  href="https://www.jotform.com/build/202824416713047?iak=3fb24825d90e0f20152b77b43824461a-e7538d72bb17fc92"
                  className="footer-link"
                  target={"_blank"}
                >
                  Register as a coach
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-secondary">
          <h4>&#169; 2021 Unschool Learning</h4>
          <h4>
            Call us on{" "}
            <a href="tel:+919154254541">+91 9154254541</a>
            {" "}to speak with a Learning Consultant
          </h4>
        </div>
      </div>
    );
  }
};

const FooterSocialLinks = ({ className }) => {
  return (
    <div className={"footer-social-container " + className || ""}>
      <div className="footer-social-icons-container">
        <a href="mailto:support@unschool.in" className="footer-social-link">
          <img src={MailIcon} alt="Mail" />
        </a>
        <a
          href="https://www.instagram.com/unschool.it"
          className="footer-social-link"
          target={"_blank"}
        >
          <img src={InstagramIcon} alt="Instagram" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCZgKk2UN8e7CDBrDa7VfGLQ"
          className="footer-social-link"
        >
          <img src={YoutubeIcon} alt="Youtube" />
        </a>
        <a
          href="https://www.linkedin.com/company/unschool-it"
          className="footer-social-link"
          target={"_blank"}
        >
          <img src={LinkedInIcon} alt="LinkedIn" />
        </a>
        <a
          href="https://www.facebook.com/unschool.in"
          className="footer-social-link"
          target={"_blank"}
        >
          <img src={FacebookIcon} alt="Facebook" />
        </a>
      </div>
    </div>
  );
};

export default Footer;

{
  {
    /* <div className={"col-md-3 desktop-hidden"}>
            <FooterSocialLinks className={"desktop-hidden"} />
          </div>
          <div className="col-md-3">
            <h1 className="footer-title">Company</h1>
            <div className="footer-links-container">
              <a href="/about" className="footer-link">
                About us
              </a>
              <a href="/contact" className="footer-link">
                Contact us
              </a>
              <a href="/community-program" className="footer-link">
                Community Program
              </a>
              <a href="/work-with-us" className="footer-link">
                Work with Us
              </a>
              <a
                target="_blank"
                href="https://community.unschool.in/signup"
                className="footer-link join-community-link"
              >
                Join our community
              </a>
              <a href="/partner-with-us" className="footer-link">
                Partner with us
              </a>
              <a
                href="https://learn.unschool.in/learn/account/signin"
                className="footer-link"
                target={"_blank"}
              >
                Sign in
              </a>
            </div>
            <h1 className="footer-title">Policies</h1>
            <div className="footer-links-container">
              <a href="/policies/disclaimer" className="footer-link">
                Disclaimer
              </a>
              <a href="/policies/terms_of_service" className="footer-link">
                Terms of Service
              </a>
              <a
                href="/policies/refund_and_cancellation"
                className="footer-link"
              >
                Refund and Cancellation
              </a>
              <a href="/policies/privacy_policy" className="footer-link">
                Privacy Policy
              </a>
              <a href="/policies/payment_terms" className="footer-link">
                Payment Terms
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <h1 className="footer-title">Browse Courses</h1>
            <div className="footer-links-container">
              <a href="/categories/design" className="footer-link">
                Art & Design
              </a>
              <a href="/categories/technology" className="footer-link">
                Technology
              </a>
              <a href="/categories/management" className="footer-link">
                Management
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <h1 className="footer-title">Become a coach</h1>
            <div className="footer-links-container">
              <a href="/become-a-coach/" className="footer-link">
                Coach with us
              </a>
              <a
                href="https://www.jotform.com/build/202824416713047?iak=3fb24825d90e0f20152b77b43824461a-e7538d72bb17fc92"
                className="footer-link"
                target={"_blank"}
              >
                Register as a coach
              </a>
            </div>
            <FooterSocialLinks className={"mobile-hidden"} />
          </div>
          <div
            className="col-md-3"
            onClick={() =>
              window.open("https://g.page/Unschool?share", "_blank")
            }
          >
            <div
              style={{ backgroundImage: `url(${MapImage})`, color: "blue" }}
              alt="Map"
              className="footer-map"
            />
            <p className="footer-subtitle">
              SNP Towers, 2nd Floor JANARDHANA HILLS SERILINGAMPALLY,
              Gachibowli, Hyderabad, Telangana 500032
            </p>
          </div>
        </div>
        <div className="row footer-secondary">
          <h4>Copyright: 2020 Unschool Learning</h4>
          <h4>
            For any assistance contact us at{" "}
            <a href={"mailto:support@unschool.in"}>support@unschool.in</a>
          </h4> */
  }
}
